// how are you buying your car
export enum BUYING_THROUGH {
  DEALER = 'dealership',
  PRIVATE = 'private',
  STILL_DECIDING = 'stillDeciding',
}
export const buyingThroughOptions = Object.values(BUYING_THROUGH)
export type BuyingThrough = (typeof buyingThroughOptions)[number]
export const buyingThroughMap = {
  [BUYING_THROUGH.DEALER]: 'Dealership',
  [BUYING_THROUGH.PRIVATE]: 'Private sale',
  [BUYING_THROUGH.STILL_DECIDING]: 'Still deciding',
}

// refactored buying through
export enum REF_BUYING_THROUGH {
  DEALER = 1,
  PRIVATE = 2,
  STILL_DECIDING = 3,
}
export const refBuyingThroughOptions = Object.values(REF_BUYING_THROUGH)
export type RefBuyingThrough = (typeof refBuyingThroughOptions)[number]
export const refBuyingThroughMap = {
  [REF_BUYING_THROUGH.DEALER]: 'Dealership',
  [REF_BUYING_THROUGH.PRIVATE]: 'Private sale',
  [REF_BUYING_THROUGH.STILL_DECIDING]: 'Still deciding',
}
